import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Alert from "@material-ui/lab/Alert";

import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";
import { blue } from "@material-ui/core/colors";

import { useHistory } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import { useSnackbar } from "notistack";
import axios from "axios";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      {/* <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{" "} */}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const ResetSchema = Yup.object().shape({
  token: Yup.string().required("Token is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string().min(3).required('Password is required'),
  confirm_password: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match')
});

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(3),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },

  submitWrapper: {
    position: "relative",
  },

  submitButton: {
    display: "block",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },

  buttonProgress: {
    color: blue[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },

  loginLink: {
    cursor: "pointer",
  },
}));

const ResetPassword = ({ match }) => {
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [success, setSuccess] = React.useState(false);
  const [buttonText, setButtonText] = React.useState(
    "Reset Password"
  );

  const [loading, setLoading] = React.useState(false);

  const { token } = match.params;

  console.log(token);

  return (
    <Container component="main" maxWidth="xs">
      <Paper className={classes.wrapper}>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            ShopX Admin Dashboard
          </Typography>

          <Formik
            initialValues={{
              token: token,
              email: "",
              password: '',
              confirm_password: '',
            }}
            validationSchema={ResetSchema}
            onSubmit={(values, actions) => {
              setLoading(true);
              setButtonText("Resetting password ...");

              axios
                .post(`auth/reset/${token}/password`, values)
                .then((response) => {
                  setLoading(false);
                  actions.setSubmitting(false);
                  setButtonText("Reset Password");

                  if (response.data && response.data.status) {
                    enqueueSnackbar(`${response.data.message}`, {
                      variant: `${response.data.status}`,
                    });

                    if (response.data.status === "success") {
                      setSuccess(true);
                    }
                  }
                })
                .catch(function (error) {
                  console.log(error.response);
                  setLoading(false);
                  actions.setSubmitting(false);
                  setButtonText("Reset Password");
                });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form noValidate autoComplete="off" className={classes.form}>
                {success ? (
                  <div>
                    <p>
                      We have successfully reset your password. You can login now with new password.
                    </p>

                    <Link
                      to="/login"
                      variant="body2"
                      className={classes.loginLink}
                      onClick={() => history.push("/login")}
                    >
                      Login to Dashboard
                    </Link>
                  </div>
                ) : (
                  <div>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      name="email"
                      label="Email Address"
                      value={values.email}
                      helperText={errors.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.email && touched.email ? true : null}
                    />

<TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="New Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={values.password}
                  helperText={errors.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.password && touched.password ? true : null}
                />

<TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="confirm_password"
                  label="Confirm Password"
                  type="password"
                  id="confirm_password"
                  autoComplete="current-confirm-password"
                  value={values.confirm_password}
                  helperText={errors.confirm_password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.confirm_password && touched.confirm_password ? true : null}
                />

                    <div className={classes.submitWrapper}>
                      <Button
                        fullWidth
                        color="primary"
                        size="large"
                        variant="contained"
                        disabled={loading}
                        onClick={handleSubmit}
                        className={classes.submitButton}
                      >
                        {buttonText}
                      </Button>
                      {loading && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </div>

                    <Typography className={classes.root} align="center">
                      <Link
                        to="/login"
                        variant="body2"
                        className={classes.loginLink}
                        onClick={() => history.push("/login")}
                      >
                        Login to Dashboard
                      </Link>
                    </Typography>
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </div>
      </Paper>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default ResetPassword;
